<template>
  <div class="project-list">
    <div class="project-item" v-for="(caseProject,index) in caseList" v-if="index < 3" @click="openCaseProject(caseProject.projectId)">
      <img v-if="caseProject.onestopProject.cover" :src="(imgUrl + caseProject.onestopProject.cover) | ossProcess(690, 320)">
      <img v-else src="../../../assets/icon-project-default-cover.png">
      <div class="project-info">
        <div class="name">{{caseProject.onestopProjectName}}</div>
        <div>{{caseProject.onestopProject.houseLayout}}</div>
      </div>
      <div class="project-evaluate">
        <div v-if="caseProject.status == '4'" class="project-status">施工中</div>
        <div v-if="caseProject.status == '5'" class="project-status">验收中</div>
        <div v-if="caseProject.status == '6'" class="project-status">已完工</div>
      </div>
    </div>
    <div class="loading-more" v-if="caseList.length > 3" @click="openCaseList()">
      <span>查看其余{{caseList.length - 3}}个</span>
    </div>
    <div v-if="caseList.length == 0" class="black-page">
      <img src="../../../assets/icon-no-img.png">
      <div class="tip">暂无相关案例!</div>
    </div>
  </div>
</template>
<script>
  import {imgUrl} from '../../../config'
  import onestopProjectSupervisorService from '../../../service/onestop/OnestopProjectSupervisorService'

  export default {
    name: 'GangmasterCaseList',
    props:['companyId'],
    data () {
      return {
        caseList:[],
        imgUrl: imgUrl,
      }
    },
    created () {
      this.imgUrl = imgUrl
      this.getCaseList()
      console.log('imgUrl==========', this.imgUrl)
    },
    methods: {
      async getCaseList(){
        var result = await onestopProjectSupervisorService.cases('', '4', 1, this.companyId);
        if(result.code == 0){
           this.caseList = [];
          for(let caseProject of result.data.result){
            if(caseProject.onestopProjectName && caseProject.onestopProjectName.length > 10){
              caseProject.onestopProjectName = caseProject.onestopProjectName.substring(0,10) + '...';
            }
            if(caseProject.status != 7){
              this.caseList.push(caseProject);
            }
          }
        }
      },
      openCaseList(){
        this.global.isLabelNum = this.isLabelNum;
        this.$router.push({name:'CompanyCaseList',query:{companyId:this.companyId}});
      },
      openCaseProject(id){
        this.global.isLabelNum = this.isLabelNum;
        this.$router.push({name:'CompanyProject',query:{id:id}});
      },
    }
  }
</script>

<style lang="scss" scoped>
  .project-list{
    width: 6.9rem;
    margin: 0 auto;
    .project-item {
      position: relative;
      margin-bottom: 0.2rem;
      box-shadow: 0rem 0.02rem 0.07rem 0rem
      rgba(0, 0, 0, 0.1);
      img{
        width: 6.9rem;
        height: 3.2rem;
        display: block;
      }
      .project-info{
        display: flex;
        height: 0.8rem;
        line-height: 0.8rem;
        font-size: 0.28rem;
        .name{
          margin-left: 0.4rem;
          margin-right: 0.5rem;
          color: #191818;
          font-size: 0.32rem;
          font-weight: bold;
        }
      }
      .project-evaluate{
        position: absolute;
        top: 0rem;
        right: 0.44rem;
        width: 0.58rem;
        height: 0.78rem;
        background: url("../../../assets/icon-evaluate-white-bg.png") no-repeat;
        background-size: 100%;
        font-size: 0.18rem;
        font-weight: bold;
        color: #222633;
        text-align: center;
        .project-status{
          margin-top: 0.2rem;
        }
      }
    }
  }
</style>

